import { render, staticRenderFns } from "./VBar.vue?vue&type=template&id=017bdcb0&"
import script from "./VBar.vue?vue&type=script&lang=js&"
export * from "./VBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports